import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, message } from "antd";
import ModalCommon from "../../components/Modal";
import RichTextEditor from "../../components/RichTextEditor";


const SetupRule = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const [rules, setRules] = useState('');
    const [term1, setTerm1] = useState('');

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            const terms = data?.terms || {};
            
            setConfigGame({
                rules: data?.rules,
                term1: terms?.term1
            });
            
            // Set initial values for editors
            setRules(data?.rules || '');
            setTerm1(terms?.term1 || '');
        } catch (err) {
            console.log(err);
            messageApi.error("Không thể tải dữ liệu cấu hình");
        }
    }, [messageApi]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleChangeInput = (value, key) => {
        switch (key) {
            case 0: setRules(value || ""); return;
            case 1: setTerm1(value || ""); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            
            const body = {
                config: {
                    rules: rules,
                    terms: {
                        term1: term1,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            
            // Reload data sau khi update thành công
            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            messageApi.error(err?.response?.data?.message || "Cập nhật thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderRichTextEditor = (key, defaultValue, changeInput, label, height = 200) => {
        const keyMap = {
            "rules": 0,
            "term1": 1
        };
        
        return (
            <div className="flex w-full items-start" style={{ marginBottom: "32px" }}>
                <div className="flex w-[20%] justify-end mr-10 pt-2">{label}:</div>
                <div className="w-[60%]">
                    <RichTextEditor 
                        value={defaultValue || ''} 
                        onChange={(value) => changeInput(value, keyMap[key])} 
                        placeholder={`Nhập ${String(label || '').toLowerCase()}...`}
                        height={height}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {renderRichTextEditor(
                                    "rules",
                                    rules, 
                                    handleChangeInput, 
                                    "Luật chơi",
                                    200
                                )}

                                {renderRichTextEditor(
                                    "term1",
                                    term1, 
                                    handleChangeInput, 
                                    "Thể lệ",
                                    200
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupRule;
